module.exports = __webpack_public_path__ + "media/images/expert__jeroen-heijers-371382e023d71458465bb2a6a81091b3.png";